import moment from "moment";
import * as actionTypes from "./constants";
import * as Service from "./services";

const getAllMobileRecommendations = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_REQUEST });
            const res = await Service.getAllMobileRecommendations(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getMobileRecommendationById = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_BY_ID_REQUEST });
            const res = await Service.getMobileRecommendationById(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_BY_ID_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_BY_ID_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATION_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MOBILE_RECOMMENDATION_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateSurveyRecommendationEntityParams = (entityParams, entity) => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_SUCCESS,
                    response: entityParams,
                    entity: entity ?? ""
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_FAILURE,
                error: entityParams,
                entity: entity ?? ""
            });
        }
    };
};

const getRecommendationVideos = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATIONS_VOICE_NOTES_REQUEST });
            const res = await Service.getRecommendationVideos(id, params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_RECOMMENDATIONS_VOICE_NOTES_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_RECOMMENDATIONS_VOICE_NOTES_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RECOMMENDATIONS_VOICE_NOTES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getMobileRecommendationTemplate = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_TEMPLATE_REQUEST });
            const res = await Service.getMobileRecommendationTemplate(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_TEMPLATE_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_TEMPLATE_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATION_TEMPLATE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MOBILE_RECOMMENDATION_TEMPLATE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const resetReducer = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_REDUCER_SUCCESS
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_REDUCER_FAILURE
            });
        }
    };
};

const resetForm = () => ({ type: actionTypes.RESET_FORM });

const getMobileRecommendationDropdowns = (entity, params, asParam, is_project_based = false) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_DROPDOWNS_REQUEST, entity });
            const res = await Service.getMobileRecommendationDropdowns(entity, params, asParam, is_project_based);
            if (res && res.status === 200) {
                const regionData = res.data;
                const dropdowndata = Object.values(regionData ?? {}).find(e => Array.isArray(e));
                if (dropdowndata) {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_DROPDOWNS_SUCCESS,
                        response: dropdowndata,
                        count: regionData?.count ?? regionData?.total_count,
                        entity
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_DROPDOWNS_FAILURE,
                        error: regionData,
                        entity
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATION_DROPDOWNS_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MOBILE_RECOMMENDATION_DROPDOWNS_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const updateMobileRecommendationFields = (id, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_MOBILE_RECOMMENDATION_FIELDS_REQUEST, response: id });
            const res = await Service.updateMobileRecommendationFields(id, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_MOBILE_RECOMMENDATION_FIELDS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_MOBILE_RECOMMENDATION_FIELDS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_MOBILE_RECOMMENDATION_FIELDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_MOBILE_RECOMMENDATION_FIELDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getMobileRecommendationCommonDataByIds = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_REQUEST });
            const res = await Service.getMobileRecommendationCommonDataByIds(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const resetMultiMobileRecommendationCommonData = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_MULTI_MR_COMMON_DATA_SUCCESS,
                response: null
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_MULTI_MR_COMMON_DATA_FAILURE,
                error: null
            });
        }
    };
};

const handleMultiMobileRecommendationUpdate = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_MULTI_MOBILE_RECOMMENDATION_REQUEST });
            const res = await Service.handleMultiMobileRecommendationUpdate(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_MULTI_MOBILE_RECOMMENDATION_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_MULTI_MOBILE_RECOMMENDATION_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_MULTI_MOBILE_RECOMMENDATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_MULTI_MOBILE_RECOMMENDATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAllMobileRecommendationIds = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_MOBILE_RECOMMENDATION_IDS_REQUEST });
            const res = await Service.getAllMobileRecommendationIds(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                dispatch({ type: actionTypes.GET_ALL_MOBILE_RECOMMENDATION_IDS_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_MOBILE_RECOMMENDATION_IDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_MOBILE_RECOMMENDATION_IDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const setAppliedFilterNames = (paramKey, names) => ({ type: actionTypes.SET_MOBILE_RECOMMENDATION_APPLIED_FILTER_NAMES, paramKey, names });

const getMobileRecommendationFilterDropdown = (param, key) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_FILTER_REQUEST, key });
            const res = await Service.getMobileRecommendationFilterDropdown(param);

            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData?.list?.length) {
                    dispatch({
                        type: actionTypes.GET_MOBILE_RECOMMENDATION_FILTER_SUCCESS,
                        response: codeData,
                        key
                    });
                } else {
                    dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_FILTER_FAILURE, error: codeData, key });
                }
            } else {
                dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_FILTER_FAILURE, error: res.response.data, key });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATION_FILTER_FAILURE, error: e.response && e.response.data, key });
        }
    };
};
const MobileRecomactivityLogRestore = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.RESTORE_DATA_LOG_REQUEST });
            const res = await Service.MobileRecomactivityLogRestore(params);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.RESTORE_DATA_LOG_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.RESTORE_DATA_LOG_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.RESTORE_DATA_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.RESTORE_DATA_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getMobileRecommendationsExport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXPORT_REQUEST });
            const response = await Service.getAllMobileRecommendations(params, true);

            if (response && response.status === 200) {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXPORT_SUCCESS,
                    response: response?.data
                });

                const blob = new Blob([response?.data]);

                let fileName = `Mobile Recommendations ${moment().format("MM-DD-YYYY")}.xlsx`;
                const disposition = response.headers?.["content-disposition"] || response.headers?.get?.("Content-Disposition");

                if (disposition) {
                    const match = disposition.match(/filename="?([^"]+)"?/);
                    if (match?.[1]) {
                        fileName = match[1];
                    }
                }

                const link = document.createElement("a");
                const url = window.URL.createObjectURL(blob);

                link.href = url;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXPORT_FAILURE,
                    error: response?.response?.data || "Download failed"
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXPORT_FAILURE,
                error: e?.response?.data || e.message
            });
        }
    };
};
const getListForMobileRecommendationFilter = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_REQUEST });
            const res = await Service.getListForMobileRecommendationFilter(params);
            if (res && res.status === 200) {
                const filterData = res.data;
                dispatch({
                    type: actionTypes.GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_SUCCESS,
                    response: filterData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getMobileRecommendationsSummaryExports = (params, surveyorExport) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_REQUEST });
            const res = await Service.getMobileRecommendationsSummaryExports(params, true);
            if (res && res.status === 200) {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_SUCCESS,
                    response: res.data
                });

                const blob = new Blob([res.data]);

                let fileName = surveyorExport
                    ? `Mobile Recommendations Surveyor Summary ${moment().format("MM-DD-YYYY")}.xlsx`
                    : `Mobile Recommendations Summary ${moment().format("MM-DD-YYYY")}.xlsx`;

                const disposition = res.headers?.["content-disposition"];
                if (disposition) {
                    const match = disposition.match(/filename="?([^"]+)"?/);
                    if (match?.[1]) {
                        fileName = match[1];
                    }
                }

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = url;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                dispatch({
                    type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_FAILURE,
                    error: res?.response?.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MOBILE_RECOMMENDATIONS_EXPORT_FAILURE,
                error: e.response?.data
            });
        }
    };
};

const getTableSummaryData = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_TABLE_SUMMARY_DATA_REQUEST });
            const res = await Service.getTableSummaryData(params);
            if (res && res.status === 200) {
                const voiceData = res.data;
                dispatch({ type: actionTypes.GET_TABLE_SUMMARY_DATA_SUCCESS, response: voiceData });
            } else {
                dispatch({
                    type: actionTypes.GET_TABLE_SUMMARY_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_TABLE_SUMMARY_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getAiAnalyseKey = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_AI_ANALYSE_KEY_REQUEST });
            const res = await Service.getAiAnalyseKey(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_AI_ANALYSE_KEY_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_AI_ANALYSE_KEY_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_AI_ANALYSE_KEY_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_AI_ANALYSE_KEY_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getGroupEditProgress = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_GROUP_EDIT_PROGRESS_REQUEST });
            const res = await Service.getGroupEditProgress(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_GROUP_EDIT_PROGRESS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_GROUP_EDIT_PROGRESS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_GROUP_EDIT_PROGRESS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_GROUP_EDIT_PROGRESS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const resetGroupEditReducer = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_GROUP_EDIT_PROGRESS_REDUCER_SUCCESS
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_GROUP_EDIT_PROGRESS_REDUCER_FAILURE
            });
        }
    };
};
const udpateScrollPosition = (entityParam, entity) => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.UPDATE_SCROLL_SUCCESS,
                response: entityParam,
                entity
            });
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SCROLL_FAILURE,
                error: e?.response,
                entity
            });
        }
    };
};
const revertRecom = recomId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.REVERT_MOBILE_RECOM_REQUEST });
            const res = await Service.revertRecom(recomId);
            if (res && res.status === 200) {
                const recomSurveyData = res.data;
                if (recomSurveyData?.success) {
                    dispatch({ type: actionTypes.REVERT_MOBILE_RECOM_SUCCESS, response: recomSurveyData });
                } else {
                    dispatch({ type: actionTypes.REVERT_MOBILE_RECOM_FAILURE, error: recomSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.REVERT_MOBILE_RECOM_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.REVERT_MOBILE_RECOM_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const revertRecomDataById = recomId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.REVERT_MOBILE_RECOM_BY_ID_REQUEST });
            const res = await Service.revertRecomDataById(recomId);
            if (res && res.status === 200) {
                const recomSurveyData = res.data;
                if (recomSurveyData) {
                    dispatch({ type: actionTypes.REVERT_MOBILE_RECOM_BY_ID_SUCCESS, response: recomSurveyData });
                } else {
                    dispatch({ type: actionTypes.REVERT_MOBILE_RECOM_BY_ID_FAILURE, error: recomSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.REVERT_MOBILE_RECOM_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.REVERT_MOBILE_RECOM_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const searchAndReplaceMobileRecommendation = (params, cb) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SEARCH_AND_REPLACE_MOBILE_RECOM_REQUEST });
            const res = await Service.searchAndReplaceMobileRecommendation(params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.SEARCH_AND_REPLACE_MOBILE_RECOM_SUCCESS, response: res.data });
                cb && cb(res.data);
            } else {
                dispatch({
                    type: actionTypes.SEARCH_AND_REPLACE_MOBILE_RECOM_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEARCH_AND_REPLACE_MOBILE_RECOM_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const findMobileRecommendationsBeforeReplace = (params, cb) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.FIND_MOBILE_RECOM_BEFORE_REPLACE_REQUEST });
            const res = await Service.findMobileRecommendationsBeforeReplace(params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.FIND_MOBILE_RECOM_BEFORE_REPLACE_SUCCESS, response: res.data });
                cb && cb();
            } else {
                dispatch({
                    type: actionTypes.FIND_MOBILE_RECOM_BEFORE_REPLACE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.FIND_MOBILE_RECOM_BEFORE_REPLACE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

export default {
    getAllMobileRecommendations,
    getMobileRecommendationById,
    updateSurveyRecommendationEntityParams,
    getRecommendationVideos,
    getMobileRecommendationTemplate,
    resetReducer,
    getMobileRecommendationDropdowns,
    updateMobileRecommendationFields,
    getMobileRecommendationCommonDataByIds,
    resetMultiMobileRecommendationCommonData,
    handleMultiMobileRecommendationUpdate,
    getAllMobileRecommendationIds,
    getMobileRecommendationFilterDropdown,
    setAppliedFilterNames,
    MobileRecomactivityLogRestore,
    getMobileRecommendationsExport,
    getListForMobileRecommendationFilter,
    resetForm,
    getMobileRecommendationsSummaryExports,
    getTableSummaryData,
    getAiAnalyseKey,
    getGroupEditProgress,
    resetGroupEditReducer,
    udpateScrollPosition,
    revertRecom,
    revertRecomDataById,
    searchAndReplaceMobileRecommendation,
    findMobileRecommendationsBeforeReplace
};
